import { Button } from '@britishcouncil/react-extro-ui';
import { FiArrowLeft, FiArrowRight } from 'react-icons/fi';
import { LuAlertTriangle, LuLogOut } from 'react-icons/lu';
import { ReactNode } from 'react';
import { useDirection } from '../../hooks';
import { Divider } from '../divider';
import * as S from './GoingBackModal.styles';
import { Trans, useTranslation } from 'react-i18next';

interface GoingBackModalCard {
  title: string;
  description: string;
  icon?: ReactNode;
}

interface GoingBackModalProps {
  onBack: () => void;
  onStay: () => void;
  title?: string;
  card1?: GoingBackModalCard;
  card2?: GoingBackModalCard;
  buttonStayLabel?: string;
  buttonBackLabel?: string;
}

export const GoingBackModal = ({
  onBack,
  onStay,
  title,
  card1,
  card2,
  buttonStayLabel,
  buttonBackLabel,
}: GoingBackModalProps) => {
  const { t } = useTranslation(['npp']);
  const dir = useDirection();

  return (
    <S.NppModal visible isOpen onClose={onStay}>
      <S.Root>
        <h4>{title ?? t('npp:modals.goingBack.title')}</h4>

        <S.CardsContainer>
          <S.Card>
            <S.CardIconWrapper>
              {card1?.icon ?? <LuLogOut size={26} />}
            </S.CardIconWrapper>
            <S.CardContent>
              <S.CardTitle>{card1?.title ?? t('npp:modals.goingBack.subtitleBeforePayment')}</S.CardTitle>
              <S.CardDescription>
                {card1?.description ?? t('npp:modals.goingBack.descriptionBeforePayment')}.
              </S.CardDescription>
            </S.CardContent>
          </S.Card>

          <S.Card>
            <S.CardIconWrapper>
              {card2?.icon ?? <LuAlertTriangle size={26} />}
            </S.CardIconWrapper>
            <S.CardContent>
              <S.CardTitle>{card2?.title ?? t('npp:modals.goingBack.subtitleAfterPayment')}</S.CardTitle>
              <S.CardDescription>
                {card2?.description ?? (
                  <Trans
                    i18nKey="npp:modals.goingBack.descriptionAfterPayment"
                    components={{ bold: <strong /> }}
                  />
                )}
                .
              </S.CardDescription>
            </S.CardContent>
          </S.Card>
        </S.CardsContainer>

        <Divider />

        <S.ButtonsContainer>
          <Button
            data-test-id="going-back-modal-stay"
            className="stay-button"
            variant="primary"
            iconLeft={dir === 'ltr' ? <FiArrowLeft size={14} /> : <FiArrowRight size={14} />}
            onClick={onStay}
          >
            {buttonStayLabel ?? t('npp:modals.goingBack.buttonStay')}
          </Button>
          <Button data-test-id="going-back-modal-back" variant="discreet" onClick={onBack}>
            {buttonBackLabel ?? t('npp:modals.goingBack.buttonBack')}
          </Button>
        </S.ButtonsContainer>
      </S.Root>
    </S.NppModal>
  );
};
